import { Box, Typography } from "@mui/material";

const SaleInvoiceBankCashDetails = ({ data }) => {
  const reg = data.registrationData;
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Bank & Cash Details</Typography>
      <Typography><strong>Account Holder:</strong> {reg?.accountHolderName || 'N/A'}</Typography>
      <Typography><strong>Bank:</strong> {reg?.bankName || 'N/A'}</Typography>
      <Typography><strong>IFSC:</strong> {reg?.ifscCode || 'N/A'}</Typography>
    </Box>
  );
};

export default SaleInvoiceBankCashDetails;